// localStorage flag for controlling display of interstitial ("about") page
export const SHOW_DEV_INTERSTITIAL = 'SHOW_DEV_INTERSTITIAL';

export const SIGN_OUT_REASONS = {
  SIGNED_OUT: 'sign-out',
  INACTIVE: 'inactive',
  MAX_SESSION: 'session',
};

export const AsyncActionState = {
  Idle: 'idle',
  Loading: 'loading',
  Failed: 'failed',
  Success: 'success',
};

// Adobe Transaction types
export const TRANSACTION_START = 'START';
export const TRANSACTION_STEP = 'STEP';
export const TRANSACTION_COMPLETE = 'COMPLETE';
export const TRANSACTION_ERROR = 'ERROR';
